import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import SignupPage from "../pages/signup/page";
import Dashboard from "../pages/dashboard/page";
import CustomersPage from "../pages/customers/page";
import CustomerDetailPage from "../pages/customers/[id]/page";
import SalesPage from "../pages/sales/page";
import NewSalePage from "../pages/sales/new/page";
import SaleDetailPage from "../pages/sales/[id]/page";
import EditSalePage from "../pages/sales/[id]/edit/page";
import PaymentsPage from "../pages/payments/page";
import NewPaymentPage from "../pages/payments/new/page";
import StockPage from "../pages/stock/page";
import ProductDetailPage from "../pages/stock/[id]/page";
import DeliveriesPage from "../pages/deliveries/page";
import ReportsPage from "../pages/reports/page";
import ExpensesPage from "../pages/expenses/page";
import CashPage from "../pages/cash/page";
import SettingsPage from "../pages/settings/page";
import ReceiptPage from "../pages/receipt/[saleId]/page";
import Layout from "../components/feature/Layout";
import AuthGuard from "../components/feature/AuthGuard";
import PromissoryNotesPage from "../pages/promissory-notes/page";
import EnforcementCasesPage from "../pages/enforcement/page";
import PaymentPromisesPage from "../pages/payment-promises/page";
import StaffPage from "../pages/staff/page";
import StaffDetailPage from "../pages/staff/[id]/page";
import StaffPaymentsPage from "../pages/staff/payments/page";
import QuoteDetailPage from "../pages/quotes/[id]/page";
import EditQuotePage from "../pages/quotes/[id]/edit/page";
import QuotesPage from "../pages/quotes/page";
import NewQuotePage from "../pages/quotes/new/page";
import PersonalLoansPage from "../pages/personal-loans/page";
import PersonalLoanDetailPage from "../pages/personal-loans/[id]/page";
import PersonalAccountsPage from "../pages/personal-accounts/page";
import PersonalAccountDetailPage from "../pages/personal-accounts/[id]/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signup",
    element: <SignupPage />,
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Dashboard /> },

      // English routes (existing)
      { path: "customers", element: <CustomersPage /> },
      { path: "customers/:id", element: <CustomerDetailPage /> },
      { path: "sales", element: <SalesPage /> },
      { path: "sales/new", element: <NewSalePage /> },
      { path: "sales/:id", element: <SaleDetailPage /> },
      { path: "sales/:id/edit", element: <EditSalePage /> },
      { path: "payments", element: <PaymentsPage /> },
      { path: "payments/new", element: <NewPaymentPage /> },
      { path: "promissory-notes", element: <PromissoryNotesPage /> },
      { path: "enforcement", element: <EnforcementCasesPage /> },
      { path: "payment-promises", element: <PaymentPromisesPage /> },
      { path: "stock", element: <StockPage /> },
      { path: "stock/:id", element: <ProductDetailPage /> },
      { path: "deliveries", element: <DeliveriesPage /> },
      { path: "reports", element: <ReportsPage /> },
      { path: "expenses", element: <ExpensesPage /> },
      { path: "cash", element: <CashPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "receipt/:saleId", element: <ReceiptPage /> },
      { path: "staff", element: <StaffPage /> },
      { path: "staff/:id", element: <StaffDetailPage /> },
      { path: "staff/payments", element: <StaffPaymentsPage /> },

      // Quotes routes
      { path: "quotes", element: <QuotesPage /> },
      { path: "quotes/new", element: <NewQuotePage /> },
      { path: "quotes/:id", element: <QuoteDetailPage /> },
      { path: "quotes/:id/edit", element: <EditQuotePage /> },

      // Turkish routes (Dashboard card navigation targets)
      { path: "ciro-raporlar", element: <ReportsPage /> },
      { path: "musteriler", element: <CustomersPage /> },
      { path: "odemeler", element: <PaymentsPage /> },
      { path: "stok-urunler", element: <StockPage /> },
      { path: "teslimatlar", element: <DeliveriesPage /> },
      { path: "senetler", element: <PromissoryNotesPage /> },
      { path: "icra-takibi", element: <EnforcementCasesPage /> },
      { path: "personel", element: <StaffPage /> },
      { path: "personel/:id", element: <StaffDetailPage /> },
      { path: "personel/odemeler", element: <StaffPaymentsPage /> },
      { path: "odeme-sozleri", element: <PaymentPromisesPage /> },

      // Personal Loans (Elden Borçlar)
      { path: "personal-loans", element: <PersonalLoansPage /> },
      { path: "personal-loans/:id", element: <PersonalLoanDetailPage /> },

      // Personal Accounts (Kişisel Hesaplar)
      { path: "personal-accounts", element: <PersonalAccountsPage /> },
      { path: "personal-accounts/:id", element: <PersonalAccountDetailPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;